import GoldenRaceHandler from "./helpers/goldenRaceHandler";
import PascalHandler from "./helpers/pascalHandler";
import LotoHandler from "./helpers/lotoHandler";

export const ThirdPartyGameEnum = {
  MadnessSweepstakes: 57,
  Madness: 1450,
  Lucky6: 400031666,
  Predictor: 371,
  Loto: 112001,
  BookOf6: 112002,
  LuckyWheel: 112003,
  Bile: 112004,
  Lottery: 42078,
  BetTVGames: 900001,
  GoldenRace: 400002,
  RocketJet: 112005,
  PascalGaming: 156147,
  JockersLuck: 112007,
  DiamondX: 112008,
  ShiningWheel: 500022253,
};

export const thirdPartyGamesConfig = {
  [ThirdPartyGameEnum.Lucky6]: { hasSecondScreen: true, tableId: 2101, limitgroupId: 1 },
  [ThirdPartyGameEnum.BookOf6]: { Handler: LotoHandler },
  [ThirdPartyGameEnum.Loto]: { Handler: LotoHandler },
  [ThirdPartyGameEnum.RocketJet]: { Handler: LotoHandler },
  [ThirdPartyGameEnum.JockersLuck]: { Handler: LotoHandler },
  [ThirdPartyGameEnum.DiamondX]: { Handler: LotoHandler },
  [ThirdPartyGameEnum.GoldenRace]: { Handler: GoldenRaceHandler },
  [ThirdPartyGameEnum.PascalGaming]: { Handler: PascalHandler },
  [ThirdPartyGameEnum.ShiningWheel]: { Handler: LotoHandler },
};

export const ThirdPartyGameIDEnum = {
  57: 'madnessSweepstakes',
  1450: 'madness',
  400031666: 'lucky6',
  371: 'predictor',
  112001: 'loto',
  112002: 'bookOf6',
  112003: 'luckyWheel',
  112004: 'bile',
  42078: 'lottery',
  900001: 'betTVGames',
  400002: 'goldenRace',
  112005: 'rocketJet',
  156147: 'pascalGaming',
  112007: 'jockersLuck',
  112008: 'diamondX',
  10412176: 'poolMasters',
};
